import { KrBadge } from '@/common/card/KrBadge';

export const BooleanCellRenderer = ({ value }) => {
  if (value == null) return <span />;

  if (value === 'Y' || value === true || value === 'TRUE') {
    return <KrBadge label="Yes" color="green" />;
  } else {
    return <KrBadge label="No" color="gray" />;
  }
};
